import { render, staticRenderFns } from "./RecommendationProgram.vue?vue&type=template&id=663bbe28&scoped=true&"
import script from "./RecommendationProgram.vue?vue&type=script&lang=js&"
export * from "./RecommendationProgram.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationProgram.vue?vue&type=style&index=0&id=663bbe28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bbe28",
  null
  
)

export default component.exports